export default __webpack_public_path__ + "static/get-to-know-italys-most-famous-beaches-fdeb779e2329ea1f201fb93af77ccb3d.jpg";